import { render, staticRenderFns } from "./teacher.vue?vue&type=template&id=6904cb07&scoped=true"
import script from "./teacher.vue?vue&type=script&lang=js"
export * from "./teacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6904cb07",
  null
  
)

export default component.exports